export enum SourceProgramEnum {
    Tablet = 2,
    Kiosk = 4,
    DigitalMeuOffline = 5,
    DigitalMeuOnline = 6
}
